import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M923.307 697.458l-144.498-16.498c-34.702-3.982-68.836 7.964-93.298 32.427l-104.676 104.676c-160.993-81.92-292.976-213.333-374.896-374.897l105.244-105.244c24.462-24.462 36.409-58.596 32.427-93.298l-16.498-143.36c-6.827-57.458-55.182-100.693-113.209-100.693h-98.418c-64.284 0-117.76 53.476-113.778 117.76 30.151 485.831 418.702 873.813 903.962 903.964 64.284 3.982 117.76-49.493 117.76-113.778v-98.418c0.569-57.458-42.667-105.813-100.124-112.64z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPhone);
export default ForwardRef;
